import React, { useState, useEffect } from 'react';
import ReactDocumentPictureInPicture from "react-document-picture-in-picture";

function PictureInPictureWindow() {
  const [time, setTime] = useState(0);

  useEffect(() => {
    const intervalRef = setInterval(() => {
      setTime(prevTime => prevTime + 1);
    }, 1000);

    return () => {
      clearInterval(intervalRef);
    };
  }, []);

  const formatTime = (seconds) => {
    const hrs = Math.floor(seconds / 3600);
    const mins = Math.floor((seconds % 3600) / 60);
    const secs = seconds % 60;
    return `${hrs.toString().padStart(2, '0')}:${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
  };

  return (
    <div style={{ padding: '20px' }}>
      <h1>Демонстрація Picture-in-Picture</h1>
      
      <ReactDocumentPictureInPicture
        width="400px"
        height="300px"
        buttonRenderer={({ open }) => (
          <button 
            onClick={open}
            style={{ 
              padding: '10px 20px',
              backgroundColor: '#4CAF50',
              color: 'white',
              border: 'none',
              borderRadius: '4px',
              cursor: 'pointer',
              fontSize: '16px'
            }}
          >
            Відкрити плаваюче вікно
          </button>
        )}
      >
        <div style={{ padding: '20px', textAlign: 'center' }}>
          <h2>Плаваюче вікно</h2>
          <p>Це вікно відображається поверх всіх інших</p>
          
          <div style={{ 
            fontSize: '48px', 
            fontWeight: 'bold', 
            margin: '20px 0',
            fontFamily: 'monospace'
          }}>
            {formatTime(time)}
          </div>
        </div>
      </ReactDocumentPictureInPicture>
    </div>
  );
}

export default PictureInPictureWindow;